import './config'
// import addons from './addons'

import store from './vuexstore'
import router from './router'

import i18n from './locale'

import './components'

import containers from './containers'
import services from './services'

const vuestrap = {i18n, store, router, services, containers}
export default vuestrap

